import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Floating back-to-top button. Appears after the user scrolls past one
// viewport, smooth-scrolls to top on click. Keyboard accessible, positioned
// to clear the footer and never overlap primary CTAs.
export function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Back to top"
      title="Back to top"
      tabIndex={visible ? 0 : -1}
      className={[
        "fixed z-40 bottom-6 right-6 sm:bottom-8 sm:right-8",
        "inline-flex h-11 w-11 items-center justify-center rounded-full",
        "border border-border bg-background/80 backdrop-blur-xl text-foreground",
        "shadow-[0_10px_30px_-10px_rgba(0,0,0,0.25)]",
        "hover:bg-primary hover:text-primary-foreground hover:border-primary",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        "transition-all duration-300",
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-3 pointer-events-none",
      ].join(" ")}
    >
      <ArrowUp className="h-4 w-4" strokeWidth={2} />
    </button>
  );
}
